import React, { Component } from 'react';

import RaisedButton from 'material-ui/RaisedButton';

import Popover from 'material-ui/Popover';

import Menu from 'material-ui/Menu';

import MenuItem from 'material-ui/MenuItem';

import { red500 } from 'material-ui/styles/colors';

class SuggestionNamesList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,

            anchorEl: null,
        };

        this.handleOpen = this.handleOpen.bind(this);

        this.handleClose = this.handleClose.bind(this);
    }

    handleOpen(ev) {
        ev.preventDefault();

        this.setState({
            open: true,

            anchorEl: ev.currentTarget,
        });
    }

    handleClose() {
        this.setState({
            open: false,
        });
    }

    menuItems(suggestedNames) {
        const { suggestedName: { _id } } = this.props;
        return suggestedNames.map((sName, index) => (
            <MenuItem
                key={index}
                value={sName.name}
                style={sName._id === _id ? { backgroundColor: 'rgb(0, 188, 212)', color: '#fff' } : null}
                primaryText={`Name: ${sName.name}; From: ${
                    sName.from
                }; Date: ${new Date(sName.date).toLocaleDateString('en-US')}`}
                onClick={() => this.changeSuggestedName(sName)}
            />
        ));
    }

    changeSuggestedName(name) {
        const { changeSuggestedName } = this.props;

        changeSuggestedName(name);

        this.setState({
            open: false,
        });
    }

    render() {
        const { nameSuggestion, suggestedName: { name } } = this.props;

        const { anchorEl, open } = this.state;

        return (
            <div
                className="col-xs"
                style={{
                    display: 'flex',

                    flexDirection: 'column',

                    alignItems: 'center',
                }}
            >
                <span className="name-block huge-name">
                    VESSEL'S SUGGESTED NAMES:
                </span>

                <RaisedButton
                    onClick={this.handleOpen}
                    label={name}
                    labelColor={red500}
                    style={{ margin: '10px 0px' }}
                />

                
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            horizontal: 'left',

                            vertical: 'bottom',
                        }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={this.handleClose}
                    >
                        <Menu>{this.menuItems(nameSuggestion)}</Menu>
                    </Popover>
                
            </div>
        );
    }
}

export default SuggestionNamesList;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/SuggestionNamesList.jsx